import Button from "../../../../../../components/bootstrap/Button";
import FormGroup from "../../../../../../components/bootstrap/forms/FormGroup";
import Input from "../../../../../../components/bootstrap/forms/Input";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../../../components/bootstrap/Modal";
import Popovers from "../../../../../../components/bootstrap/Popovers";
import Spinner from "../../../../../../components/bootstrap/Spinner";
import Money from "../../../../../../helpers/utils/money/money";

const ComplementsModalBlock = ({
    isOpen,
    selectedProduct,
    complementCategories,
    getComplementsByCategory,
    collapsedState,
    onToggleCollapse,
    onClose,
    loadingComplementCategoryStatus,
    loadingComplementStatus,
    loadingComplementPrices,
    loadingDeleteComplementCategory,
    loadingDeleteComplement,
    onToggleComplementCategoryStatus,
    onToggleComplementStatus,
    onEditComplementPrice,
    onSaveComplementPrice,
    onRequestDeleteComplementCategory,
    onRequestDeleteComplement,
}) => {
    return (
        <Modal
            id="modal-ifood-complements-by-category"
            isOpen={isOpen}
            setIsOpen={(value) => {
                if (!value) onClose();
            }}
            isStaticBackdrop
            isCentered
            size="xl"
        >
            <ModalHeader setIsOpen={onClose}>
                <ModalTitle id="modal-title-ifood-complements">
                    Complementos - {selectedProduct?.name || "Produto"}
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                {!complementCategories.length ? (
                    <div className="alert alert-warning mb-0">
                        Este produto não possui categorias de complemento configuradas.
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        {complementCategories.map((category) => {
                            const categoryComplements = getComplementsByCategory(category);
                            return (
                                <div key={category.id} className="border rounded">
                                    <div
                                        className="d-flex justify-content-between align-items-center p-3 bg-light border-bottom border rounded"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => onToggleCollapse(category.id)}
                                    >
                                        <div>
                                            <div className="fw-bold">{category.name}</div>
                                            <small className="text-muted">
                                                Min {category.min_item} / Max {category.max_item}
                                            </small>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {loadingComplementCategoryStatus[category.id] ? (
                                                <Spinner />
                                            ) : (
                                                <Button
                                                    isLink
                                                    color={category.status ? "success" : "warning"}
                                                    icon="Circle"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        onToggleComplementCategoryStatus(category);
                                                    }}
                                                >
                                                    {category.status ? "Ativo" : "Desativado"}
                                                </Button>
                                            )}
                                            <Popovers trigger="hover" title="Remover categoria de complemento">
                                                <Button
                                                    isLink
                                                    color="danger"
                                                    icon="Delete"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        onRequestDeleteComplementCategory(category);
                                                    }}
                                                    disabled={loadingDeleteComplementCategory[category.id]}
                                                />
                                            </Popovers>
                                        </div>
                                    </div>

                                    {collapsedState[category.id] ? null : !categoryComplements.length ? (
                                        <div className="alert alert-light mt-3 mb-0">
                                            Nenhum complemento vinculado para esta categoria.
                                        </div>
                                    ) : (
                                        <div className="table-responsive p-3 pt-2">
                                            <table className="table table-striped align-middle">
                                                <thead>
                                                    <tr>
                                                        <th>Nome</th>
                                                        <th>Delivery Code</th>
                                                        <th>Preço iFood</th>
                                                        <th>Status</th>
                                                        <th>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categoryComplements.map((item) => (
                                                        <tr key={item.id}>
                                                            <td>{item.name}</td>
                                                            <td>{item.delivery_code || "-"}</td>
                                                            <td style={{ maxWidth: 180 }}>
                                                                <FormGroup className="mb-0">
                                                                    <Input
                                                                        value={Money.centsToMaskMoney(item.ifoodPrice)}
                                                                        onChange={(e) => onEditComplementPrice(item.id, e.target.value)}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                            <td>
                                                                {loadingComplementStatus[item.id] ? (
                                                                    <Spinner />
                                                                ) : (
                                                                    <Button
                                                                        isLink
                                                                        color={item.status ? "success" : "warning"}
                                                                        icon="Circle"
                                                                        onClick={() => onToggleComplementStatus(item)}
                                                                    >
                                                                        {item.status ? "Ativo" : "Desativado"}
                                                                    </Button>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex gap-2">
                                                                    <Popovers trigger="hover" title="Salvar preço complemento">
                                                                        <Button
                                                                            isLink
                                                                            onClick={() => onSaveComplementPrice(item)}
                                                                            icon={loadingComplementPrices[item.id] ? "HourglassEmpty" : "save"}
                                                                            disabled={loadingComplementPrices[item.id]}
                                                                        />
                                                                    </Popovers>
                                                                    <Popovers trigger="hover" title="Remover complemento">
                                                                        <Button
                                                                            isLink
                                                                            color="danger"
                                                                            icon="Delete"
                                                                            onClick={() => onRequestDeleteComplement(item)}
                                                                            disabled={loadingDeleteComplement[item.id]}
                                                                        />
                                                                    </Popovers>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" isLight onClick={onClose}>
                    Fechar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ComplementsModalBlock;
